import { toRef, ref, computed, resolveComponent, createBlock, openBlock, withCtx, createElementVNode, mergeProps, createVNode, unref, createElementBlock, normalizeProps } from "vue";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import { imgUtils } from "../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css               */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "./index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                  */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import { useTheme } from "../../composables/useTheme.js";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                       */
/* empty css                                    */
import { VHover } from "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                      */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css               */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                   */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                      */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                  */
import "vuetify/components/VFileInput";
/* empty css                            */
import { VAvatar } from "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                         */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                            */
import "vuetify/components/VItemGroup";
/* empty css                       */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                  */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
/* empty css                 */
const _hoisted_1 = ["src"];
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "BanzaAvatar",
  props: {
    contact: {
      type: Object,
      default: null
    },
    photoId: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: "primary"
    },
    borderWidth: {
      type: Number,
      default: 2
    },
    preset: {
      type: String,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const { preset, attrs, resolveColor } = useTheme({
      componentKey: "BanzaAvatar",
      presetName: toRef(() => props.preset)
    });
    const hasError = ref(false);
    const hasOnClickListener = computed(() => {
      return attrs.value.onClick || attrs.value.href;
    });
    const avatarSrc = computed(() => {
      return props.image ? props.image : props.photoId ? imgUtils.getAvatarUrl(props.photoId) : imgUtils.getAvatarUrlByContact(props.contact);
    });
    const containerAttrs = computed(() => {
      var _a, _b;
      return ((_b = (_a = preset.value.slots) == null ? void 0 : _a.container) == null ? void 0 : _b.attrs) || {};
    });
    const iconAttrs = computed(() => {
      var _a, _b;
      const AVATAR_ICON_SCALE = 0.85;
      return {
        ...((_b = (_a = preset.value.slots) == null ? void 0 : _a.icon) == null ? void 0 : _b.attrs) || {},
        ...props.icon && { icon: props.icon },
        size: props.size * AVATAR_ICON_SCALE
      };
    });
    const colorCss = computed(() => resolveColor(attrs.value.color || props.color));
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      return openBlock(), createBlock(VHover, null, {
        default: withCtx(({ isHovering, props: hoverProps }) => [
          createElementVNode("div", mergeProps({ class: "d-inline-block" }, containerAttrs.value), [
            createVNode(VAvatar, mergeProps({
              class: [
                "b-avatar",
                {
                  ["c-pointer"]: hasOnClickListener.value,
                  ["hover"]: hasOnClickListener.value && isHovering
                },
                props.preset
              ],
              style: props.preset === "outlined" ? {
                ["color"]: `${colorCss.value} !important`,
                ["background"]: "transparent !important",
                ["border"]: `${__props.borderWidth}px solid ${colorCss.value}`
              } : {},
              size: __props.size,
              color: colorCss.value
            }, {
              ...unref(attrs),
              ...hasOnClickListener.value && hoverProps
            }), {
              default: withCtx(() => [
                avatarSrc.value && !hasError.value ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  class: "b-avatar__image",
                  src: avatarSrc.value,
                  "aspect-ratio": 1,
                  onError: _cache[0] || (_cache[0] = ($event) => hasError.value = true)
                }, null, 40, _hoisted_1)) : (openBlock(), createBlock(_component_b_icon, normalizeProps(mergeProps({ key: 1 }, iconAttrs.value)), null, 16))
              ]),
              _: 2
            }, 1040, ["class", "style", "size", "color"])
          ], 16)
        ]),
        _: 1
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
